enum TradeProgramStatus {
  CONFIGURATION = "CONFIGURATION",
  ENROLLMENT = "ENROLLMENT",
  PROFILE = "PROFILE",
  PROFILE_ADMIN = "PROFILE_ADMIN",
  SELECTION_ROUND_1 = "SELECTION_ROUND_1",
  SELECTION_ROUND_1_ADMIN = "SELECTION_ROUND_1_ADMIN",
  SELECTION_ROUND_2 = "SELECTION_ROUND_2",
  SELECTION_ROUND_2_ADMIN = "SELECTION_ROUND_2_ADMIN",
  SELECTION_ROUND_3 = "SELECTION_ROUND_3",
  SELECTION_ROUND_3_ADMIN = "SELECTION_ROUND_3_ADMIN",
  MEETING_MATCHING = "MEETING_MATCHING",
  ACCEPT_MEETINGS = "ACCEPT_MEETINGS",
  INVITES_SENT = "INVITES_SENT",
  IN_PROGRESS = "IN_PROGRESS",
  RECONCILIATION = "RECONCILIATION",
  FEEDBACK = "FEEDBACK",
  REIMBURSEMENT = "REIMBURSEMENT",
  COMPLETED = "COMPLETED"
}

enum TradeProgramStatusByValue {
  CONFIGURATION = 0,
  ENROLLMENT,
  PROFILE,
  PROFILE_ADMIN,
  SELECTION_ROUND_1,
  SELECTION_ROUND_1_ADMIN,
  SELECTION_ROUND_2,
  SELECTION_ROUND_2_ADMIN,
  SELECTION_ROUND_3,
  SELECTION_ROUND_3_ADMIN,
  MEETING_MATCHING,
  ACCEPT_MEETINGS,
  INVITES_SENT,
  IN_PROGRESS,
  RECONCILIATION,
  FEEDBACK,
  REIMBURSEMENT,
  COMPLETED
}
namespace TradeProgramStatus {
  export function isBetweenEnrollmentAndSelectionRound2(status?: TradeProgramStatus): boolean {
    if (!status) return false;
    const statusValue = TradeProgramStatusByValue[status];
    return (
      statusValue >= TradeProgramStatusByValue.ENROLLMENT && statusValue <= TradeProgramStatusByValue.SELECTION_ROUND_2
    );
  }
  export function isBetweenEnrollmentAndBeforeMeetingMatching(status?: TradeProgramStatus): boolean {
    if (!status) return false;
    const statusValue = TradeProgramStatusByValue[status];
    return (
      statusValue >= TradeProgramStatusByValue.ENROLLMENT && statusValue < TradeProgramStatusByValue.MEETING_MATCHING
    );
  }
}

export default TradeProgramStatus;

export const PRODUCT_FIELDS_ENABLED_STATUS_LIST = [TradeProgramStatus.CONFIGURATION, TradeProgramStatus.ENROLLMENT];
